export enum ColumnTypeEnum {
  Text,
  Button,
  Chip,
  Actions,
  TextWithHover
}
